import Farmacopeia from "../models/farmacopeiaModel";

import { iServiceCached } from "./base/iServiceCached";

class FarmacopeiaService extends iServiceCached<Farmacopeia> {
    constructor() {
        super("Farmacopeia");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.descricao,
        }));
    }
}

export default new FarmacopeiaService();
